import { EntityType } from '@augloop-types/honeybee';
import type { IEditor } from 'roosterjs-editor-types';
import { SonoraHintType, SonoraViewState } from 'owa-editor-sonora-types';
import { getIntentDetectionTeachingBubbleText } from './getIntentDetectionHintNodeText';
import {
    showTeachingBubble,
    updateIntentDetectionHint,
    hideTeachingBubble,
    resetTeachingBubbleTimer,
} from '../../mutators/sonoraHintMutators';
import { logSimpleSonoraDatapoint } from '../../dataLogger/logSonoraDatapoint';

const TEACHING_BUBBLE_PERSIST_TIME_IN_MS = 5000;

export default function handleTeachingBubbleInEditor(
    viewState: SonoraViewState,
    editor: IEditor | undefined,
    entityType: EntityType | undefined,
    triggerCharacter: string
): void {
    if (editor && entityType) {
        const nodeText = getIntentDetectionTeachingBubbleText(entityType, triggerCharacter);
        if (nodeText != '') {
            let rect = editor.getSelectionRange().getBoundingClientRect();
            showTeachingBubble(viewState, nodeText, { x: rect.left, y: rect.bottom });
            updateIntentDetectionHint(viewState, entityType);
            logSimpleSonoraDatapoint('SonoraHintDisplayedOnIntentDetected', {
                sessionId: viewState.sessionId,
                entityType: EntityType[entityType],
                triggerCharacter: triggerCharacter,
                hintType: SonoraHintType[SonoraHintType.TeachingBubble],
            });

            resetTeachingBubbleTimer(
                viewState,
                window.setTimeout(() => {
                    if (viewState.shouldShowTeachingBubble) {
                        hideTeachingBubble(
                            viewState,
                            triggerCharacter,
                            `timeout ${TEACHING_BUBBLE_PERSIST_TIME_IN_MS}`
                        );
                    }
                }, TEACHING_BUBBLE_PERSIST_TIME_IN_MS)
            );
        }
    }
}
